import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import merge from 'lodash.merge';
export default (function (analytics) {
  for (var _len = arguments.length, configs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    configs[_key - 1] = arguments[_key];
  }
  analytics && analytics.push(function (dataLayer) {
    return merge.apply(void 0, [{
      type: 'impression'
    }].concat(_toConsumableArray(configs.map(function (configFn) {
      return configFn ? configFn(dataLayer) : {};
    }))));
  });
});